// TODO: Lodash should no longer be used here
// eslint-disable-next-line no-restricted-imports
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

import { ReactComponent as NoDataImage } from '../../assets/images/mirage/no-docs-image.svg';

export type NoDataMessageProps = {
  image?: any;
  message?: string;
  sub?: string;
  CallToActionComponent?: React.FC;
};

const NoDataMessage = ({ image, message, sub, CallToActionComponent }: NoDataMessageProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center text-center">
      {image ? image : <NoDataImage className="size-36 object-contain" />}

      <div className="text-2xl" data-testid="no-data-message">
        {!isEmpty(message) ? message : t('Hey, hey! You are new here...')}
      </div>

      {!isEmpty(sub) && <div className="text-xl text-gray-800">{sub}</div>}

      {CallToActionComponent && (
        <>
          <br />
          <br />
          <CallToActionComponent />
        </>
      )}
    </div>
  );
};

export default NoDataMessage;
